
export default {
  mailchimpAssigner: {
    path: '/social-media/mailchimp-assigner',
    beforeEnter: function (to, from, next) {
      return next('/communications/external-media-assigner')
    }
  },
  externalMediaAssigner: {
    path: '/social-media/external-media-assigner',
    beforeEnter: function (to, from, next) {
      return next('/communications/external-media-assigner')
    }
  }
}



// WEBPACK FOOTER //
// ./src/router/socialMedia.js